export const LEGACY = 'legacy';
export const MAIN = 'main';



// WEBPACK FOOTER //
// ./src/common/constants/video-image-type.js